import usePrivateAxios from "@/common/api/usePrivateAxios"
import { unFormatUnknownUnit } from "@/common/utils/unFormatters"
import { EditEquipmentUsageValidationSchema } from "@/features/privateCompanies/components/EditEquipmentUsageModal/schema"
import { UseMutationResult, useMutation } from "@tanstack/react-query"

interface useUpdateEquipmentUsageOptions {
  equipmentId: string
  categoryId?: string
  onSuccess?: () => void
  onError?: (error: Error) => void
}

const useUpdateEquipmentUsage = ({ equipmentId, categoryId, onSuccess, onError }: useUpdateEquipmentUsageOptions): UseMutationResult<void, Error, EditEquipmentUsageValidationSchema> => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationFn: async ({ value, reason, file, }: EditEquipmentUsageValidationSchema) => {
      await privateAxios.postForm(`/client/equipments/${equipmentId}/last_usage_declaration`, {
        last_usage_declaration: {
          value: value ? unFormatUnknownUnit(value) : undefined,
          reason,
          file,
          category_id: categoryId,
        }
      })
    },
    onSuccess,
    onError,
  })
}

export default useUpdateEquipmentUsage
